module.exports = __webpack_public_path__ + "img/icon-hardware-wallet.78248a8e.png";